function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.022 -68.103)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.022,
    cy: 73.103,
    r: 5,
    fill: "#00e64d",
    style: {
      mixBlendMode: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/drawing.36549c13cd1e74bf3b336e892c863c89.svg";
export { ForwardRef as ReactComponent };